/**
 * The gardener's pain as a block quote: their words in green italic display
 * type, a 4px green rule down its left, and a big faded opening quotation
 * mark behind the first line. No avatar and no name (it is a type of
 * gardener's thought, not a testimonial).
 *
 * The green is the theme's primary, so it stays readable in the dark theme.
 *
 * Used by: components/FeatureBlock.tsx (the remodelled landing page).
 *
 * @module PainQuote
 */

import React from 'react';

/** What the quote holds. */
interface PainQuoteProps {
  /** Their words, without quotation marks (text, or text with an emphasised word). */
  children: React.ReactNode;
}

/**
 * A pain line as a block quote.
 *
 * @param props.children - Their words.
 */
export const PainQuote: React.FC<PainQuoteProps> = ({ children }) => (
  <blockquote
    className="relative m-0 max-w-md border-l-4 border-primary py-1.5 pl-[22px] text-left before:absolute before:-top-[34px] before:left-3.5 before:font-grow before:text-[72px] before:font-extrabold before:leading-none before:text-primary before:opacity-25 before:content-['\201C']"
  >
    <p className="m-0 font-grow text-[22px] font-semibold italic leading-[1.3] text-primary">{children}</p>
  </blockquote>
);
